module.exports = __webpack_public_path__ + "caroline.jpg?c307fa74377dd23850135f633862402c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/caroline.jpg
// module id = 80
// module chunks = 0